import React from 'react';
import './Label.css'
import { view } from 'react-easy-state';

export default view((props) => (
  <label className={"label " + (props.className ? props.className : '')}>{props.children}</label>
));